// Attach a LiveKit preview track to the studio's shared preview <video> element while
// keeping the element's mute state aligned with the operator's choice.
//
// The studio preview's audio and video ride ONE <video> element (so the browser lip-syncs
// them). LiveKit's attachToElement() unconditionally runs
//   element.muted = mediaStream.getAudioTracks().length === 0
// every time a track is attached. On the shared element that means attaching the video
// track while the audio track is present force-UNMUTES it — and a reconnect (e.g. after a
// VPN connect/disconnect) re-subscribes and re-attaches both tracks. Without reasserting
// our own intent afterwards the court audio starts playing while the UI still shows the
// preview muted (DEV-866). Always reapply `muted` after attach so the two can't diverge.
export const attachPreviewTrack = (track, el, muted) => {
  track.attach(el)
  el.muted = muted
}
